import { RedirectCommand, ResolveFn, Router } from '@angular/router';
import { LagerplatzInhalt } from '@softapps/lager/core';
import { inject, INJECTOR } from '@angular/core';
import { ProductRelocationRepository } from '../repositories/product-reloaction.repository';
import { ProductRelocationService } from '../services/product-relocation.service';
import { isDefinedNotEmpty } from '@softline/core';
import { handleRequestError, isBackNavigation } from '@softline/application';

export function isStandardPallet(pallet: LagerplatzInhalt): boolean {
  return (
    pallet?.palette?.mischpalette === 'J' ||
    isDefinedNotEmpty(pallet?.palette?.kunde) ||
    pallet?.inhalt.some((o) => o.artikel?.palettenArtikel === true)
  );
}

export const palletByBarcodeResolver: (
  redirectToDestination: boolean
) => ResolveFn<LagerplatzInhalt> = (redirectToDestination) => {
  return async (route) => {
    const repo = inject(ProductRelocationRepository);
    const service = inject(ProductRelocationService);
    const injector = inject(INJECTOR);
    const router = inject(Router);
    const palletBarcode = route.paramMap.get('pallet');

    if (!palletBarcode)
      return new RedirectCommand(router.createUrlTree(['/product-relocation']));

    const navigation = router.currentNavigation();
    const storedPallet = service.loadedPallet();

    // When navigating back
    if (isBackNavigation(navigation) && storedPallet) {
      return isStandardPallet(storedPallet.result)
        ? new RedirectCommand(router.createUrlTree(['/product-relocation']))
        : storedPallet?.result;
    } else if (storedPallet && storedPallet.code === palletBarcode) {
      const result = storedPallet?.result;

      if (isStandardPallet(result) && redirectToDestination) {
        service.update('quellLagerplatz', result.lagerplatz);
        service.update('artikelMenge', result.inhalt);
        service.update('palette', result?.palette);
        return new RedirectCommand(
          router.createUrlTree([
            '/product-relocation',
            palletBarcode,
            result.inhalt[0].artikel.id,
            'destination',
          ])
        );
      }

      return storedPallet.result;
    }

    try {
      const result = await repo.findPallet(palletBarcode);
      service.loadedPallet.set({
        code: palletBarcode,
        result,
      });

      if (isStandardPallet(result)) {
        service.update('quellLagerplatz', result.lagerplatz);
        service.update('artikelMenge', result.inhalt);
        service.update('palette', result?.palette);
        return isBackNavigation(navigation)
          ? result
          : new RedirectCommand(
              router.createUrlTree([
                '/product-relocation',
                palletBarcode,
                result.inhalt[0].artikel.id,
                'destination',
              ])
            );
      }

      return result;
    } catch (e) {
      handleRequestError(e, injector, { show: true });
      return new RedirectCommand(router.createUrlTree(['/product-relocation']));
    }
  };
};
